import { siteStats } from "@/mocks/posts";

export default function StatBand() {
  return (
    <section className="w-full bg-accent-500">
      <div className="w-full px-4 md:px-8 py-6 md:py-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {siteStats.map((stat) => (
            <div key={stat.label} className="flex items-center gap-3">
              <span className="flex h-10 w-10 md:h-12 md:w-12 shrink-0 items-center justify-center rounded-lg bg-accent-950/15 text-accent-950">
                <i className={`${stat.icon} text-xl md:text-2xl`} aria-hidden="true"></i>
              </span>
              <div>
                <p className="font-heading text-xl md:text-2xl font-bold text-accent-950">
                  {stat.value}
                </p>
                <p className="text-xs md:text-sm text-accent-950/75">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}